var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.info}},[(!_vm.is_header)?_c('header_nav'):_vm._e(),_vm._v(" "),_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.wxTitle),expression:"wxTitle"}]}),_vm._v(" "),(!_vm.is_foot)?_c('foot'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6cd85a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 